import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { formatDurationSeconds } from './timeEntries';
import { colors } from '../../core/theme/theme';

export interface TimeEntryGroupHeaderProps {
  label: string;
  count: number;
  totalSeconds: number;
}

/**
 * Divider row rendered above each group of entries. Shows the group
 * label, entry count, and cumulative duration — handy to spot
 * whether one designation or teammate concentrates most of the hours.
 */
export default function TimeEntryGroupHeader({
  label,
  count,
  totalSeconds,
}: TimeEntryGroupHeaderProps) {
  const { t } = useTranslation();
  return (
    <Box
      data-testid={`time-entry-group-${label}`}
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        px: 2,
        py: 1,
        backgroundColor: colors.lightGray,
        borderTop: `1px solid ${colors.lightGray}`,
      }}
    >
      <Typography
        variant="overline"
        sx={{ fontWeight: 700, letterSpacing: 0.5 }}
      >
        {label}
      </Typography>
      <Typography variant="caption" color="text.secondary" sx={{ fontVariantNumeric: 'tabular-nums' }}>
        {t('kronos.projectTab.groupSummary', {
          count,
          total: formatDurationSeconds(totalSeconds),
        })}
      </Typography>
    </Box>
  );
}
